import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

export default function InputAutocomplete({
  id,
  options,
  label,
  onChange,
  value,
  isOptionEqualToValue,
  onBlur,
  error,
  helperText,
  required,
}) {
  // Función para manejar el evento onBlur
  const handleBlur = (event, reason) => {
    // Llamar a la función onBlur pasada como prop con el id del campo
    onBlur(id);
  };
  return (
    <Autocomplete
      disablePortal
      id={id}
      options={options}
      getOptionLabel={(option) => option.name} // Se muestra el nombre en la interfaz
      onChange={onChange}
      onBlur={handleBlur}
      value={value}
      isOptionEqualToValue={isOptionEqualToValue}
      //sx={{ width: '100%', marginTop: '16px', marginBottom: '8px' }}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#fff",
          borderRadius: "8px",
        },
        "& .MuiInputBase-input": {
          backgroundColor: "#fff !important",
          borderRadius: "8px",
          WebkitBoxShadow: "0 0 0 1000px white inset",
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={helperText}
          required={required}
        />
      )}
    />
  );
}
